import type {
  DevAsset,
  DevPlanState,
  DevPlanSummary,
} from '../DevelopmentPlan/types';

/** The newest plan among the published, non-hidden plans returned by /plans. */
export function latestVisiblePlan(
  plans: DevPlanSummary[],
): DevPlanSummary | undefined {
  return plans.reduce<DevPlanSummary | undefined>(
    (latest, plan) => (!latest || plan.id > latest.id ? plan : latest),
    undefined,
  );
}

/** Built games that are actually linked to nodes in this plan. The /me assets
 * pool is global, so node_games is the membership boundary for the Games tab. */
export function linkedBuiltGames(state: DevPlanState): DevAsset[] {
  const linkedKeys = new Set(state.node_games.map(game => game.asset_key));
  return state.assets.filter(
    asset =>
      asset.kind === 'game' && asset.is_built && linkedKeys.has(asset.key),
  );
}
